import React from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import "./Notification.css";

function NotificationPage() {
    return (
        <div className="app-container">
            <Sidebar />
            <main className="main-content">
                <h1 className="main-title">Notification Page</h1>
                <p className="main-description">Welcome to the Notification page!</p>
            </main>
        </div>
    );
}

export default NotificationPage;